export default __webpack_public_path__ + "static/media/garbageBasket.9fb573ae.svg";